<template>
  <v-form v-model="businessDetail" ref="form">
    <v-row class="w--100">
      <v-row class="w--100 pa-4">
        <h4 class="mx-3 blue--text">نوع کسب و کار</h4>
        <HelperComponent helperId="how-it-work-1120" class="mt-1" />
      </v-row>
      <v-col cols="12" class="mb-3">
        <v-radio-group
          v-model="formType"
          row
          required
          :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
          @change="(event) => changeFormType(event)"
          :disabled="merchantIsApproved"
        >
          <v-radio
            style="margin-right: 0; margin-left: 16px"
            v-for="companyType in companyTypeGroups"
            :key="companyType.id"
            :label="companyType.title"
            :value="companyType.id"
          ></v-radio>
        </v-radio-group>
      </v-col>

      <v-col cols="12" class="mb-3">
        <v-sheet outlined class="pa-1 pa-md-7">
          <v-container>
            <v-row>
              <v-col v-if="formType == '1'" cols="12" sm="6">
                <ValidationProvider name="نام شرکت" rules="required">
                  <v-text-field
                    @blur="checkValidName($event, 'نام شرکت')"
                    label="نام شرکت *"
                    required
                    :rules="[
                      (v) => {
                        if (v && v.length < 3) {
                          return `نام شرکت حداقل بایستی 3 کاراکتر باشد`;
                        } else if (v && v.length >= 3 && companyNameErrors) {
                          return companyNameErrors;
                        } else if (!v) {
                          return 'وارد کردن مقدار الزامی میباشد';
                        } else {
                          return true;
                        }
                      },
                    ]"
                    v-model="form.company.name"
                    type="text"
                    outlined
                    dense
                    :disabled="
                      merchantIsApproved && !merchantMonitorFields.CompanyName
                        ? true
                        : false
                    "
                  />
                </ValidationProvider>
              </v-col>

              <v-col cols="12" sm="6" v-if="formType == '2' || formType == '3'">
                <ValidationProvider name="نام کسب و کار" rules="required">
                  <v-text-field
                    :disabled="
                      merchantIsApproved && !merchantMonitorFields.Name
                        ? true
                        : false
                    "
                    @blur="checkValidName($event, 'نام کارگاه/کسب وکار')"
                    label="نام کارگاه/کسب وکار *"
                    v-model="form.name"
                    required
                    :rules="[
                      (v) => {
                        if (v && v.length < 3) {
                          return `نام کسب و کار حداقل بایستی 3 کاراکتر باشد`;
                        } else if (v && v.length >= 3 && companyNameErrors) {
                          return companyNameErrors;
                        } else if (!v) {
                          return 'وارد کردن مقدار الزامی میباشد';
                        } else {
                          return true;
                        }
                      },
                    ]"
                    type="text"
                    outlined
                    dense
                    clearable
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" v-if="formType == '2'">
                <v-text-field
                  label="کد ایسیک"
                  v-model="form.company.isic"
                  type="number"
                  outlined
                  dense
                  :disabled="
                    merchantIsApproved && !merchantMonitorFields.Isic
                      ? true
                      : false
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" v-if="formType == '2'">
                <v-text-field
                  label="شناسه صنفی"
                  v-model="form.company.guildId"
                  type="number"
                  outlined
                  dense
                  :disabled="
                    merchantIsApproved && !merchantMonitorFields.GuildId
                      ? true
                      : false
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" v-if="formType == '1'">
                <v-text-field
                  @blur="checkValidNationalId($event)"
                  @input="isValiNationalId = ''"
                  label="شناسه ملی *"
                  placeholder="َشناسه ملی معتبر وارد شود "
                  v-model="form.company.nationalId"
                  required
                  :rules="[
                    (v) => {
                      if (v && v.length < 3) {
                        return ` حداقل بایستی 3 کاراکتر باشد`;
                      } else if (v && v.length >= 3 && isValiNationalId) {
                        return isValiNationalId;
                      } else if (!v) {
                        return 'وارد کردن مقدار الزامی میباشد';
                      } else {
                        return true;
                      }
                    },
                  ]"
                  type="number"
                  outlined
                  dense
                  :disabled="
                    merchantIsApproved && !merchantMonitorFields.NationalId
                      ? true
                      : false
                  "
                />
              </v-col>

              <v-col cols="12" sm="6" v-if="formType == '1'">
                <v-text-field
                  label="شماره ثبت *"
                  v-model="form.company.registrarNumber"
                  required
                  :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
                  type="number"
                  outlined
                  dense
                  :disabled="
                    merchantIsApproved && !merchantMonitorFields.RegistrarNumber
                      ? true
                      : false
                  "
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  label="نوع ثبت *"
                  v-model="form.company.companyType"
                  outlined
                  required
                  :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
                  item-text="companyTypeTitle"
                  item-value="companyType"
                  dense
                  :items="registerTypeList"
                  :disabled="
                    merchantIsApproved && !merchantMonitorFields.CompanyType
                      ? true
                      : false
                  "
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="سال تاسیس"
                  v-model="form.yearOfFoundation"
                  type="number"
                  :rules="[
                    (v) => {
                      if (v && (v < 1300 )) {
                        return 'سال تاسیس باید چهار رقمی  باشد مانند ۱۳۹۸ ';
                      } else return true;
                    },
                  ]"
                  outlined
                  dense
                  :disabled="
                    merchantIsApproved &&
                    !merchantMonitorFields.YearOfFoundation
                      ? true
                      : false
                  "
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="تعداد کارکنان"
                  v-model="form.numberOfEmployee"
                  type="number"
                  outlined
                  dense
                  :disabled="
                    merchantIsApproved &&
                    !merchantMonitorFields.NumberOfEmployee
                      ? true
                      : false
                  "
                />
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-col>
      <v-col cols="12" class="mb-3">
        <v-sheet outlined class="pa-1 pa-md-7">
          <v-container>
            <v-row>
              <v-col cols="12" md="6" v-if="form.phones && form.phones[0]">
                <v-text-field
                  label="تلفن دفتر کار *"
                  v-model="form.phones[0].phoneNumber"
                  type="number"
                  outlined
                  dense
                  required
                  :rules="[
                    (v) =>
                      !!v ||
                      'شماره تلفن دفتر بصورت عدد و با پیش کد شهری با صفر شروع شود .',
                  ]"
                  :disabled="merchantIsApproved"
                />
              </v-col>
              <v-col cols="12" md="6" v-if="form.phones && form.phones[1]">
                <v-text-field
                  label="تلفن همراه *"
                  v-model="form.phones[1].phoneNumber"
                  :disabled="merchantIsApproved"
                  type="number"
                  outlined
                  dense
                  required
                  :rules="[
                    (v) => {
                      if (!v) {
                        return 'وارد کردن مقدار الزامی میباشد';
                      } else if (v && !/^(\d{11,11})+$/.test(v)) {
                        return 'تلفن حتما باید عدد و 11 رقم باشد';
                      } else return true;
                    },
                  ]"
                  counter="11"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  label="َشماره تماس بیشتری از اینجا اضافه کنید"
                  :items="phoneTypeItems"
                  item-text="displayName"
                  item-value="title"
                  v-model="selectedPhoneTypes"
                  multiple
                  dense
                  outlined
                  append-icon="$close"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-row v-if="selectedPhoneTypes && selectedPhoneTypes.length">
                  <v-col
                    v-for="(item, index) in form.phones"
                    :key="index"
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-if="index >= 2"
                      :label="' شماره ' + item.title"
                      placeholder="َشماره تلفن وارد کنید یا این فیلد را حذف کنید"
                      v-model="form.phones[index].phoneNumber"
                      type="number"
                      required
                      :rules="[
                        (v) => {
                          if (!v) {
                            return 'وارد کردن مقدار الزامی است(در صورت عدم  تمایل این فیلد را حذف کنید- آیکون سمت راست کلیک کنید)';
                          } else return true;
                        },
                      ]"
                      outlined
                      dense
                      @click:prepend-inner="removePhoneType(item)"
                      prepend-inner-icon="mdi-trash-can"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="ایمیل"
                  v-model="form.email"
                  outlined
                  dense
                  :disabled="
                    merchantIsApproved && !merchantMonitorFields.Email
                      ? true
                      : false
                  "
                />
              </v-col>
              <v-col cols="12" md="6" v-if="isEdit">
                <v-combobox
                  deletable-chips
                  v-model="form.permittedSignerNames"
                  hide-selected
                  label="افراد دارای حق امضا"
                  placeholder="َنام و نام خانوادگی را وارد و کلید Enter را فشار دهید. نفرات بعدی هم به همین شکل اضافه شود."
                  multiple
                  persistent-hint
                  small-chips
                  outlined
                  dense
                  clearable
                  flat
                  hide-no-data
                  :disabled="
                    merchantIsApproved &&
                    !merchantMonitorFields.PermittedSignerNames
                      ? true
                      : false
                  "
                >
                </v-combobox>
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');
const merchantRepository = () => RepoFactory.get('merchant');
export default {
  props: {
    validateDetail: {
      type: Boolean,
      default: false,
    },
    nameForCompany: {
      type: String,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    businessRegistrationData: {
      type: Object,
      default: null,
    },
    merchantIsApproved: {
      type: Boolean,
      default: false,
    },
    merchantMonitorFields: {
      type: Object,
      default: null,
    },
    addNewMerchantCompany: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        phones: [
          {
            title: 'کار',
            type: 'Work',
            phoneNumber: null,
          },
          {
            title: 'همراه',
            type: 'Mobile',
            phoneNumber: null,
          },
        ],
        company: {
          name: null,
          brandName: null,
          nationalId: null,
          registrarNumber: null,
          economicCode: null,
          taxCode: null,
          companyType: null,
          isic: null,
          guildId: null,
        },
        email: '',
        name: '',
        yearOfFoundation: '',
        numberOfEmployee: null,
        permittedSignerNames: [],
      },
      formType: '3',
      businessDetail: true,
      phoneTypeItems: [],
      registerTypeList: [],
      companyNameErrors: '',
      isValiNationalId: '',
      selectedPhoneTypes: [],
    };
  },
  computed: {
    ...mapGetters(['companyTypeGroups']),
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
  },
  created() {
    if (this.formType == 3) {
      this.form.company.companyType = 'PersonalBusiness';
    }
    if (!this.isEdit && this.formType == 3) {
      this.form.name = this.nameForCompany;
      this.form.company.name = this.nameForCompany;
    }

    if (!this.isEdit) {
      this.getRegisterCompanyTypeItems();
    }
    this.getCompanyTypeGroups();
    this.getPhoneType();
    if (this.nameForCompany && !this.isEdit) {
      //this.form.name = this.nameForCompany;
      // this.form.company.name = this.nameForCompany;
    }
    if (this.isEdit && this.businessRegistrationData) {
      this.fillValue(this.businessRegistrationData);
    }
    if (this.addNewMerchantCompany) {
      if (this.businessRegistrationData.phones) {
        const Mobile = this.businessRegistrationData.phones.find(
          (el) => el.type == 'Mobile'
        );
        if (Mobile) {
          const element = this.form.phones.find((el) => el.type == 'Mobile');
          element.phoneNumber = Mobile.phoneNumber;
        }
        const Work = this.businessRegistrationData.phones.find(
          (el) => el.type == 'Work'
        );
        if (Work) {
          const element = this.form.phones.find((el) => el.type == 'Work');
          element.phoneNumber = Work.phoneNumber;
        }
      }
    }
  },
  watch: {
    nameForCompany(after, before) {
      if (!this.isEdit) {
        this.form.name = after;
        this.form.company.name = after;
      }
    },
    formType(after, before) {
      if (after == 3 && !this.isEdit) {
        this.form.company.companyType = 'PersonalBusiness';
      }
    },
    validateDetail(aft, bef) {
      if (aft) {
        if (this.$refs.form.validate()) {
          if (this.formType == 1) {
            this.form.name = this.form.company.name;
          }
          if (this.formType == 3) {
            this.form.company.name = this.form.name;
          }
          if (this.formType == 2) {
            this.form.company.name = this.form.name;
          }
          console.log('next step');
          console.log(this.form);
          this.$emit('nextStep', this.form, 'businessDetail');
        } else {
          this.$emit('validationFailed');
        }
      }
    },
    selectedPhoneTypes() {
      let selectedPhoneObj = null;
      let index = null;
      this.phoneTypeItems.forEach((x, i) => {
        if (this.selectedPhoneTypes.includes(x.title)) {
          selectedPhoneObj = x;
          index = i;
        }
      });
      this.addPhoneType(selectedPhoneObj, index);
    },
  },
  methods: {
    resetForm() {
      this.form = {
        phones: [
          {
            title: 'کار',
            type: 'Work',
            phoneNumber: null,
          },
          {
            title: 'همراه',
            type: 'Mobile',
            phoneNumber: null,
          },
        ],
        company: {
          name: null,
          brandName: null,
          nationalId: null,
          registrarNumber: null,
          economicCode: null,
          taxCode: null,
          companyType: null,
          isic: null,
          guildId: null,
        },
        email: '',
        name: '',
        yearOfFoundation: '',
        numberOfEmployee: null,
        permittedSignerNames: [],
      };
    },
    fillValue(data) {
      this.form = {
        company: {
          name: data.company.name,
          brandName: data.company.brandName,
          nationalId: data.company.nationalId,
          registrarNumber: data.company.registrarNumber,
          economicCode: data.company.economicCode,
          taxCode: data.company.taxCode,
          companyType: data.company.companyType,
          isic: data.company.isic,
          guildId: data.companyguildId,
        },
        phones: data.phones,
        email: data.email,
        name: data.name,
        yearOfFoundation: data.yearOfFoundation,
        numberOfEmployee: data.numberOfEmployee,
        permittedSignerNames: data.permittedSignerNames,
      };
      this.formType = data.companyTypeGroupItemDto.companyTypeGroupId;
      this.getRegisterCompanyTypeItems();
    },
    getPhoneType() {
      const loader = this.$loading.show();
      return new Promise((resolve, reject) => {
        enumsRepository()
          .getEnum('PhoneType', this.merchantBaseUrl)
          .then(({ data }) => {
            this.phoneTypeItems = data.filter(
              (x) => x.title != 'Work' && x.title != 'Mobile'
            );
            resolve();
          })
          .catch((error) => {
            reject(error);
            Helper.handleErrors(error, this);
          })
          .finally(() => {
            loader.hide();
          });
      });
    },
    removePhoneType(item) {
      this.form.phones.forEach((x, i) => {
        if (x.type == item.type) {
          this.form.phones.splice(i, 1);
          this.phoneTypeItems.push({ title: x.type, displayName: x.title });
          this.selectedPhoneTypes.splice(
            this.selectedPhoneTypes.indexOf(item.type),
            1
          );
        }
      });
    },
    addPhoneType(obj, index) {
      if (obj) {
        this.form.phones.push({
          title: obj.displayName,
          type: obj.title,
          phoneNumber: '',
        });
        this.phoneTypeItems.splice(index, 1);
      }
    },
    changeFormType(val) {
      if (
        this.isEdit &&
        this.formType ==
          this.businessRegistrationData?.companyTypeGroupItemDto
            ?.companyTypeGroupId
      ) {
        this.form.company.name = this.businessRegistrationData.company.name;
        this.form.company.brandName =
          this.businessRegistrationData.company.brandName;
        this.form.company.nationalId =
          this.businessRegistrationData.company.nationalId;
        this.form.company.registrarNumber =
          this.businessRegistrationData.company.registrarNumber;
        this.form.company.economicCode =
          this.businessRegistrationData.company.economicCode;
        this.form.company.taxCode =
          this.businessRegistrationData.company.taxCode;
        this.form.company.companyType =
          this.businessRegistrationData.company.companyType;
        this.form.company.isic = this.businessRegistrationData.company.isic;
        this.form.company.guildId =
          this.businessRegistrationData.companyguildId;
        this.form.name = this.businessRegistrationData.name;
      } else {
        this.form.company.name = this.form.name;
        this.nameForCompany = this.form.name;
        this.form.company.brandName = null;
        this.form.company.nationalId = null;
        this.form.company.registrarNumber = null;
        this.form.company.economicCode = null;
        this.form.company.taxCode = null;
        this.form.company.companyType = null;
        this.form.company.isic = null;
        this.form.company.guildId = null;
      }
      this.getRegisterCompanyTypeItems();

      if (val === '1') {
        this.form.name = null;
        this.form.company.isic = null;
        this.form.company.guildId = null;
      } else if (val === '2') {
        this.form.company.name = null;
        this.form.company.nationalId = null;
        this.form.company.registrarNumber = null;
      } else {
        this.form.company.name = null;
        this.form.company.nationalId = null;
        this.form.company.registrarNumber = null;
        this.form.company.isic = null;
        this.form.company.guildId = null;
      }
    },
    getCompanyTypeGroups() {
      const loader = this.$loading.show();
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('getCompanyTypeGroups')
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error);
            Helper.handleErrors(error, this);
          })
          .finally(() => {
            loader.hide();
          });
      });
    },
    async checkValidName(event, name) {
      try {
        const params = {
          merchantName: event.target.value,
        };
        const response = await merchantRepository().forbidenNamesValidate(
          this.merchantBaseUrl,
          params
        );
        if (!response.data.isValid) {
          this.companyNameErrors = response.data.message;
        } else {
          this.companyNameErrors = '';
        }
      } catch (error) {
        this.companyNameErrors = '';
      }
    },
    async checkValidNationalId(event) {
      try {
        const params = {
          nationalId: event.target.value,
        };
        if (this.isEdit) {
          params.id = this.$route.params.id;
        }
        const response = await merchantRepository().checkIsValiNationalId(
          this.merchantBaseUrl,
          {},
          params
        );

        if (!response.data.isValid) {
          this.isValiNationalId = response.data.message;
        } else {
          this.isValiNationalId = '';
        }
      } catch (error) {
        this.isValiNationalId = '';
      }
    },
    getRegisterCompanyTypeItems() {
      const loader = this.$loading.show();
      return new Promise((resolve, reject) => {
        const params = {
          companyTypeGroupId: this.formType,
        };
        merchantRepository()
          .getCompanytypegroupItems(this.merchantBaseUrl, params)
          .then(({ data }) => {
            this.registerTypeList = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
            Helper.handleErrors(error, this);
          })
          .finally(() => {
            loader.hide();
          });
      });
    },
  },
};
</script>

<style></style>
